<h3>
  <label>Master Leads</label>
  <ng-container style="display:inline-block">
    <button [style.background-color]="getColor(uploadFlag)" (click)="displayUpload()">Modify</button>
  </ng-container>
  <ng-container style="display:inline-block">
    <button (click)="exportLeadsCSV()" id="export_button">Export as .csv</button>
  </ng-container>
  <ng-container style="display:inline-block">
    <span>Count: {{rowCount}}</span>
  </ng-container>
</h3>
<ng-container *ngIf="uploadFlag; else sendlabel" style="display:inline;">
  <mastersheet-upload (open_close)="receiveFlag($event)" [inUidList]="headerUIDList"></mastersheet-upload>
</ng-container>
<ng-template #sendlabel>
</ng-template>
<div>
  <mastersheetstable #child (rowCountEvent)="receiveCount($event)" (uidList)="receiveUIDList($event)"></mastersheetstable>
</div>
